import { writable } from "svelte/store";
export const astroData = writable({
    planets: [
        { naam: "Zon", pos: 0.0, snel: 0.0 },
        { naam: "Maan", pos: 0.0, snel: 0.0 },
        { naam: "Mercurius", pos: 0.0, snel: 0.0 },
        { naam: "Venus", pos: 0.0, snel: 0.0 },
        { naam: "Mars", pos: 0.0, snel: 0.0 },
        { naam: "Jupiter", pos: 0.0, snel: 0.0 },
        { naam: "Saturnus", pos: 0.0, snel: 0.0 },
        { naam: "Uranus", pos: 0.0, snel: 0.0 },
        { naam: "Neptunus", pos: 0.0, snel: 0.0 },
        { naam: "Pluto", pos: 0.0, snel: 0.0 },
        { naam: "Noordknoop", pos: 0.0, snel: 0.0 }
    ],
    houses: [
        { house: "1", long: 0.0 },
        { house: "2", long: 0.0 },
        { house: "3", long: 0.0 },
        { house: "4", long: 0.0 },
        { house: "5", long: 0.0 },
        { house: "6", long: 0.0 },
        { house: "7", long: 0.0 },
        { house: "8", long: 0.0 },
        { house: "9", long: 0.0 },
        { house: "10", long: 0.0 },
        { house: "11", long: 0.0 },
        { house: "12", long: 0.0 }
    ]
});
//export const planeten = astroData.planets;
//export const huizen = astroData.houses;
// Path: src\stores\birthData.js